var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-result"},[_c('div',{staticClass:"c-head"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('Table',{attrs:{"height":_vm.height,"columns":_vm.columns,"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }